import { render, staticRenderFns } from "./CardContainer.vue?vue&type=template&id=f0675dba&scoped=true"
import script from "./CardContainer.vue?vue&type=script&lang=js"
export * from "./CardContainer.vue?vue&type=script&lang=js"
import style0 from "./CardContainer.vue?vue&type=style&index=0&id=f0675dba&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0675dba",
  null
  
)

export default component.exports